const stringIsNumber = (val: string): boolean | '' | 0 => {
  return val && val.length && !isNaN(Number(val.toString()));
};

const scrollToTop = (): void => scrollTo({ selector: '[data-mountpoint]' });

const scrollTo = ({ selector }: { selector: string }): void => {
  const element = document.querySelector<HTMLDivElement>(selector);

  if (element) {
    window.scrollTo({
      top: element.offsetTop - Math.floor((window.innerHeight * 20) / 100),
    });
  }
};

export { stringIsNumber, scrollToTop };
